import React, { useState, useEffect, useRef, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Icon, Button, Loader } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  SemanticTable,
  Texto,
  Select,
} from "./styles";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";

const SpecialsVounchers = (props) => {
  const [indicacoes, setIndicacoes] = useState([]);
  const pagina = useRef(1);

  useEffect(() => {
    loadAuth();
    loadSpecialsVouchers();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadSpecialsVouchers = async () => {
    await api
      .get(`admin/cupom/direcionado?page=${pagina.current}`)
      .then(async (res) => {
        let logs = {
          local: "controleIndicacoes/specialVounchers",
          texto: `listou os os Specials Vounchers`,
        };
        await api.post("system_logs", { acao: JSON.stringify(logs) });
        setIndicacoes(res.data);
      })
      .catch((err) => {
        swal("Não foi possível carregar as indicações", err, "error");
      });
  };

  const verifyPessoaNome = (nome) => {
    if (nome == null) {
      return "Pessoa não existente";
    } else {
      return nome.nome;
    }
  };
  const verifyPessoaEmail = (email) => {
    if (email == null) {
      return "Pessoa não existente";
    } else {
      return email.email;
    }
  };

  const verifyCupomCodigo = (codigo) => {
    if (codigo == null) {
      return "Codigo não existente";
    } else {
      return codigo.codigo;
    }
  };

  const verifyCupomDesconto = (desconto) => {
    if (desconto == null) {
      return "Desconto não existente";
    } else {
      return desconto.desconto;
    }
  };
  const verifyCupomEmail = (email) => {
    if (email == null) {
      return " Email Não existente";
    } else {
      return email.email;
    }
  };

  const verifyCupomAplicavel = (aplicavel) => {
    if (aplicavel == null) {
      return "Não existente";
    } else {
      return aplicavel.aplicavel;
    }
  };

  const proximaPagina = () => {
    pagina.current = pagina.current + 1;
    loadSpecialsVouchers();
  };
  const paginaAnterior = () => {
    if (pagina.current != 1) {
      pagina.current = pagina.current - 1;
      loadSpecialsVouchers();
    } else {
      swal("não é possivel voltar pois essa é a primeira pagina", "", "error");
    }
  };
  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title>Controle de Indicações SpecialsVounchers</Title>
          <SemanticTable size="big" celled>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>Nome</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Email</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Cupom</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Desconto</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Email Cupom</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Aplicavel</SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>
            {indicacoes.length > 0 ? (
              <SemanticTable.Body>
                {indicacoes.map((indicacao, index) => (
                  <SemanticTable.Row>
                    <SemanticTable.Cell>
                      {verifyPessoaNome(indicacao.pessoa)}
                    </SemanticTable.Cell>
                    <SemanticTable.Cell>
                      {verifyPessoaEmail(indicacao.pessoa)}
                    </SemanticTable.Cell>
                    <SemanticTable.Cell>
                      {verifyCupomCodigo(indicacao.cupom)}
                    </SemanticTable.Cell>
                    <SemanticTable.Cell>
                      {verifyCupomDesconto(indicacao.cupom)}%
                    </SemanticTable.Cell>
                    <SemanticTable.Cell>
                      {verifyCupomEmail(indicacao.cupom)}
                    </SemanticTable.Cell>
                    <SemanticTable.Cell>
                      {verifyCupomAplicavel(indicacao.cupom)}
                    </SemanticTable.Cell>
                  </SemanticTable.Row>
                ))}
              </SemanticTable.Body>
            ) : (
              <h3>Nenhuma indicação encontrado</h3>
            )}
          </SemanticTable>
          <Button floated="right" onClick={proximaPagina}>
            Poxima Pagina
          </Button>
          <Button floated="left" onClick={paginaAnterior}>
            Pagina Anterior
          </Button>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(SpecialsVounchers);
